import React, { useEffect } from 'react';
import { useStoreon } from 'storeon/react';
import PropTypes from 'prop-types';
import Select from "../Select";
import Input from "../Input";
import { useFormContext } from "react-hook-form";
import getShipTo from "../../getShipTo/getShipTo";
import emailValidationRules from '../../constants/validateEmail';

const DealerContactInformationWesternWindows = ( props ) => {
    const { index, number = true } = props;
    const { groups } = useStoreon( 'groups' );
    const { watch, trigger, register, setValue } = useFormContext();
    const { service_type: serviceType = '' } = watch()

    // These two fields are conditional and used to show additional fields base on value.
    // We have to trigger validation when one of theme go changed so that we can use our logic
    // for fieldsets visibility.

    const {account, region} = getShipTo();

    useEffect( () => {
        trigger();
    }, [trigger, serviceType] );

    useEffect(() => {
        register('location');
    }, [register]);

    useEffect(() => {
        setValue('location', region || '94');
    }, [setValue, region]);

    return (
        <fieldset className="form-block" disabled={groups[index].disabled}>
            <legend className="form-block__title">{number ? index + 1 + '. ' : ''}Dealer Contact Information</legend>
            <div className="row">
                <div className="col col-12 col-md-6 col-xl-3">
                    <Input
                        label="Ship To Account #"
                        name="dealer_account"
                        rules={{
                            required: 'This field is required.',
                        }}
                        defaultValue={account}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col col-12 col-md-6 col-xl-3">
                    <Input
                        label="Dealer Contact’s First Name"
                        name="dealer_first_name"
                        rules={{
                            required: 'This field is required.',
                        }}
                    />
                </div>
                <div className="col col-12 col-md-6 col-xl-3">
                    <Input
                        label="Dealer Contact’s Last Name"
                        name="dealer_last_name"
                        rules={{
                            required: 'This field is required.',
                        }}
                    />
                </div>
                <div className="col col-12 col-md-6 col-xl-3">
                    <Input
                        label="Dealer‘s Email Address"
                        name="dealer_email_address"
                        type="email"
                        rules={emailValidationRules()}
                    />
                </div>
                <div className="col col-12 col-md-6 col-xl-3">
                    <Input
                        label="Dealer’s Phone Number"
                        name="dealer_phone"
                        rules={{
                            required: 'This field is required.',
                            pattern: {
                                value: /^[0-9]{10}$/,
                                message: 'The phone number should contain only 10 digits (ex. 5555555555) with no spaces.',
                            },
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col col-12 col-md-6 col-xl-3">
                    <Select
                        label="Service Type"
                        name="service_type"
                        options={[
                            {
                                value: 'Service Request',
                                label: 'Service request',
                            },
                            {
                                value: 'Mailed Parts – Dealer',
                                label: 'Ship parts to dealer',
                            },
                            {
                                value: 'Mailed Parts',
                                label: 'Ship parts to customer',
                            },
                        ]}
                        rules={{
                            required: 'This field is required.',
                        }}
                    />
                </div>
                {serviceType && (
                    <div className="col col-12 col-md-6 col-xl-3">
                        <Select
                            label="Priority"
                            name="priority"
                            options={[
                                {
                                    value: 'Standard',
                                    label: 'Standard',
                                },
                                {
                                    value: 'Security/Safety Issue',
                                    label: 'Security/Safety Issue',
                                },
                                {
                                    value: 'Delayed Payment',
                                    label: 'Delayed Payment',
                                },
                            ]}
                            rules={{
                                required: 'This field is required.',
                            }}
                        />
                    </div>
                )}
            </div>

            {!groups[index].disabled && groups[index + 1] && groups[index + 1].disabled && (
                <div className={'form-block__error'}>
                    You must fill in all required fields prior to moving to the next section.
                </div>
            )}
        </fieldset>
    );
};

DealerContactInformationWesternWindows.propTypes = {
    index: PropTypes.number.isRequired,
};

export default DealerContactInformationWesternWindows;
